/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { finalizeAction, ActionType } from '@/store/actions';
import { UserPointLog } from '@/api/types/user';

export interface StoreUserCoinListState {
  limit: number;
  kw: string;
  list: UserPointLog[];
  loaded: boolean;
  loading: boolean;
  nextPoint: number;
  noMore: boolean;
  balance: number;
}

export default {
  namespaced: true,
  state: {
    limit: 10,
    kw: null,
    list: [],
    loaded: false,
    loading: false,
    nextPoint: null,
    noMore: false,
    balance: null,
  },
  getters: {},
  actions: {
    [USER.GET_COIN_LOG]({ state, commit }, { action: rawAction = '', kw }: { action?: ActionType; kw?: string } = {}) {
      const action = finalizeAction(rawAction, state.loaded && state.kw === kw, state.noMore);
      if (action && !state.loading) {
        commit(USER.GET_COIN_LOG, { status: 'start' });
        const point = action === 'reload' ? null : state.nextPoint;
        return new Promise((resolve, reject) => {
          api.getCoinLog(point, state.limit, kw).then((res) => {
            commit(USER.GET_COIN_LOG, {
              status: 'success',
              kw,
              action,
              data: res.data,
              balance: res.extra.balance,
              nextPoint: res.extra.nextPoint,
            });
            resolve();
          }).catch(() => {
            commit(USER.GET_COIN_LOG, { status: 'failure' });
            reject();
          });
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [USER.GET_COIN_LOG](state, { status, kw, action, data, balance, nextPoint }) {
      if (status === 'start') {
        state.loading = true;
      } else {
        if (status === 'success') {
          state.loaded = true;
          state.kw = kw;
          state.list = action === 'reload' ? data : state.list.concat(data);
          state.balance = balance;
          state.noMore = !nextPoint;
          state.nextPoint = nextPoint;
        }
        state.loading = false;
      }
    },
  },
};
